<template>
  <keep-alive>
    <v-container
      fluid
      style="height: 100%; padding:0px; min-height: inherit; max-width: 1500px"
      class="d-flex flex-column"
    >
      <div
        style="height: 100%; padding:0px; min-height: inherit; max-width: 1500px"
        class="d-flex flex-row"
      >
        <agency-left-section
          class="hidden-sm-and-down"
          v-if="profileType == 'Agency'"
        />
        <volunteer-left-section
          class="hidden-sm-and-down"
          v-else-if="profileType == 'Volunteer'"
        />
        <admin-left-section
          class="hidden-sm-and-down"
          v-else-if="profileType == 'Admin'"
        />

        <calendar-feed-section v-if="profileType === 'Volunteer' || profileType == 'Agency'" />
        <not-found v-else />
        <agency-right-section
          class="hidden-md-and-down"
          v-if="profileType == 'Agency'"
        />
        <volunteer-right-section
          class="hidden-md-and-down"
          v-else-if="profileType == 'Volunteer'"
        />
        <admin-right-section
          class="hidden-md-and-down"
          v-else-if="profileType == 'Admin'"
        />
      </div>
      <v-snackbar v-model="snackbar">
        {{ errorMessage }}
      </v-snackbar>
    </v-container>
  </keep-alive>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import VolunteerLeftSection from "../volunteer/VolunteerLeftSection.vue";
import AgencyLeftSection from "../agency/AgencyLeftSection.vue";
import CalendarFeedSection from "./CalendarFeedSection.vue";
import AgencyRightSection from "../agency/AgencyRightSection.vue";
import VolunteerRightSection from "../volunteer/VolunteerRightSection.vue";
import AdminLeftSection from "../admin/home/AdminHomeSideMenu.vue";
import AdminRightSection from "../admin/AdminRightSection";
import NotFound from "../NotFound.vue";
export default {
  components: {
    AgencyLeftSection,
    VolunteerLeftSection,
    CalendarFeedSection,
    AgencyRightSection,
    VolunteerRightSection,
    AdminRightSection,
    AdminLeftSection,
    NotFound
  },
  data() {
    return {
      loading: false,
      errorMessage: null,
      snackbar: false,
      notifications: [],
      errorCalendars: []
    };
  },
  methods: {
    ...mapActions("event", {
      fetchAllEvents: "fetchAllEvents"
    }),
    showErrorMessage(message) {
      this.errorMessage = message;
      this.snackbar = true;
    }
  },
  computed: {
    ...mapGetters({
      profileType: "auth/getType"
    })
  }
};
</script>
<style scoped></style>
